export const REDUX_PROMPT_TYPES = {
  MATCH_LOADS: 'MATCH_LOADS',
  MATCH_TRUCKS: 'MATCH_TRUCKS',
  ASSIGN_LOADS: 'ASSIGN_LOADS',
  ASSIGN_TRUCKS: 'ASSIGN_TRUCKS',
  UPDATE_PLATES: 'UPDATE_PLATES',
  PROMPTS: 'PROMPTS',
  GENERATE_ORDER_DOC: 'GENERATE_ORDER_DOC',
  MAIL_TEMPLATE: 'MAIL_TEMPLATE',
  STATUS_UPDATE: 'STATUS_UPDATE',
  REQUEST_UPDATE: 'REQUEST_UPDATE',
  SHOW_DOC: 'SHOW_DOC',
  TRANSACTION_FIXED: 'TRANSACTION_FIXED'
}

export const dispatchGenerateOrderDoc = (data) => (dispatch) => dispatch({
  type: REDUX_PROMPT_TYPES.GENERATE_ORDER_DOC,
  payload: data
})

export const dispatchUpdatePlateNumbers = (data) => (dispatch) => dispatch({
  type: REDUX_PROMPT_TYPES.UPDATE_PLATES,
  payload: data
})

export const dispatchStatusUpdate = (data) => (dispatch) => dispatch({
  type: REDUX_PROMPT_TYPES.STATUS_UPDATE,
  payload: data
})

export const dispatchRequestUpdate = (data) => (dispatch) => dispatch({
  type: REDUX_PROMPT_TYPES.REQUEST_UPDATE,
  payload: data
})

export const dispatchShowDoc = (data) => (dispatch) => dispatch({
  type: REDUX_PROMPT_TYPES.SHOW_DOC,
  payload: data
})

export const dispatchMatchTruck = (transaction) => (dispatch) => dispatch({
  type: REDUX_PROMPT_TYPES.MATCH_TRUCKS,
  payload: transaction
})

export const dispatchMatchLoad = (transaction) => (dispatch) => dispatch({
  type: REDUX_PROMPT_TYPES.MATCH_LOADS,
  payload: transaction
})

export const dispatchFixedTransaction = (isFixed) => (dispatch) => dispatch({
  type: REDUX_PROMPT_TYPES.TRANSACTION_FIXED,
  payload: isFixed
})
